import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon, { GLYPHS } from '../icon';
import { KNOWLEDGE_CENTER_TOOLTIP } from './constants';

const KnowledgeArticleLink = ({
  url,
  tooltip,
  showTooltipOnTheLeft,
}) => (
  <span className="c-info-tooltip-new-handler">
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon glyph={GLYPHS.question} className="c-link-blue" />
    </a>
    <div
      className={classnames(
        'c-info-tooltip-new__content',
        { 'c-info-tooltip-new__content-left': showTooltipOnTheLeft }
      )}
      display-if={!!tooltip}
    >
      {tooltip}
    </div>
  </span>
);

KnowledgeArticleLink.propTypes = {
  url: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  showTooltipOnTheLeft: PropTypes.bool,
};

KnowledgeArticleLink.defaultProps = {
  tooltip: KNOWLEDGE_CENTER_TOOLTIP,
  showTooltipOnTheLeft: false,
};

export default KnowledgeArticleLink;
